/* Keep variant labels + gallery image in sync for <hdt-variant-picker> */
(() => {
  const ROOT_SEL = 'hdt-variant-picker';
  const FIELDSET_SEL = 'fieldset.hdt-product-form__input[data-index]';
  const INPUT_SEL = 'input[is-value], select[is-value]';
  const DROPDOWN_BTN_SEL = '[role="option"][value]'; // dropdown chips

  function getVariantsJSON(root) {
    const el = root.querySelector('script[type="application/json"][data-variants-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function currentSelections(root) {
    const groups = [...root.querySelectorAll(FIELDSET_SEL)];
    return groups.map(fs => {
      // radio/hidden/select are all marked with is-value in this theme
      const checked = fs.querySelector('input[is-value][type="radio"]:checked');
      const hidden  = fs.querySelector('input[is-value][type="hidden"]');
      const select  = fs.querySelector('select[is-value]');
      return (checked && checked.value) || (hidden && hidden.value) || (select && select.value) || '';
    });
  }

  function resolveVariant(variants, selValues) {
    if (!variants || !variants.length) return null;
    // Shopify variants carry variant.options = [opt1, opt2, opt3]
    const complete = selValues.every(v => v && v.length);
    if (!complete) {
      return variants.find(v => v.available) || variants[0] || null;
    }
    return variants.find(v => {
      if (!Array.isArray(v.options)) return false;
      return v.options.every((vOpt, i) => String(vOpt) === String(selValues[i]));
    }) || null;
  }

  function updateLegends(root, selValues) {
    [...root.querySelectorAll(FIELDSET_SEL)].forEach((fs, idx) => {
      const span = fs.querySelector('[update-value]');
      if (span && typeof selValues[idx] === 'string') span.textContent = selValues[idx] || '';
    });
  }

  function getGallery() {
    // supports your left-thumbs gallery & sticky image
    return (
      document.querySelector('hdt-media-gallery') ||
      document.querySelector('media-gallery') ||
      document.querySelector('product-media-gallery') ||
      document.querySelector('.hdt-product-media__main') ||
      document.querySelector('[data-product-gallery]')
    );
  }

  function goToMedia(mediaId) {
    if (!mediaId) return false;
    const gallery = getGallery();

    // 1) Native method used by this theme (if present)
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(String(mediaId), true);
      return true;
    }

    // 2) Click thumbnail with matching data-media-id / Slide-<id>
    const thumb =
      document.querySelector(`[data-media-id="${mediaId}"]`) ||
      document.querySelector(`[data-media-id="shopify-${mediaId}"]`) ||
      document.querySelector(`[id*="Slide-${mediaId}"]`);
    if (thumb) {
      (thumb.querySelector('button, a, img') || thumb).dispatchEvent(new Event('click', { bubbles: true }));
      return true;
    }

    // 3) Fallback: scroll into view
    const candidate =
      document.querySelector(`[data-media-id]`) ||
      document.querySelector(`[id*="Slide-"]`);
    if (candidate) {
      candidate.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
    return false;
  }

  function sync(root) {
    const variants = getVariantsJSON(root);
    if (!variants) return;
    const sel = currentSelections(root);
    const variant = resolveVariant(variants, sel);
    updateLegends(root, sel);
    const mediaId = variant && (variant.featured_media && variant.featured_media.id || variant.featured_image && variant.featured_image.id);
    if (mediaId) goToMedia(mediaId);
  }

  // Wire up listeners (works even if theme events fail)
  document.addEventListener('change', (e) => {
    if (!e.target.closest(ROOT_SEL)) return;
    if (!e.target.matches(INPUT_SEL)) return;
    const root = e.target.closest(ROOT_SEL);
    sync(root);
  });

  // Handle dropdown chip clicks
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(DROPDOWN_BTN_SEL);
    if (!btn) return;
    const root = e.target.closest(ROOT_SEL);
    if (!root) return;
    // give the theme a tick to update hidden input, then sync
    setTimeout(() => sync(root), 0);
  });

  // Respect the theme’s own custom event if it fires
  document.addEventListener('variant:change', (e) => {
    const root = e.target && e.target.closest ? e.target.closest(ROOT_SEL) : document.querySelector(ROOT_SEL);
    if (root) sync(root);
  });

  // Initial sync
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(ROOT_SEL).forEach(sync);
  });
})();